import Sidebar from '@/components/Sidebar'
import DashboardHeader from '@/components/DashboardHeader'
import BlogGeneratorForm from '@/components/BlogGeneratorForm'

export default function BlogGeneratorPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-800 transition-colors">
      <Sidebar />
      <div className="lg:pl-64">
        <DashboardHeader title="Blog Meta Generator" />
        <main className="px-4 sm:px-6 lg:px-8 py-8">
          <div className="max-w-4xl mx-auto">
            <div className="glass-card rounded-xl p-6">
              <BlogGeneratorForm />
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

